<template>
  <div>
    <aside class="main-sidebar">
      <section
        class="sidebar"
        v-show="usuarioLogado.basic && usuarioLogado.basic.idUsuario"
      >
        <transition name="fade">
          <updater v-show="!isMenuToggled"></updater>
        </transition>
        <ul class="sidebar-menu" data-widget="tree">
          <li class="header">NAVEGAÇÃO</li>
          <li
            :key="idx"
            v-for="(route, idx) in routes"
            :class="{'treeview': route.children }"
          >
            <template v-if="!route.children">
              <a :href="`#${route.path}`">
                <i :class="route.meta.icon"></i>
                <span>{{route.meta.label}}</span>
              </a>
            </template>
            <template v-else>
              <a
                :href="`#`"
                @click.prevent
              >
                <i :class="groupIcons[route.name]"></i>
                <span>{{route.name}}</span>
                <span class="pull-right-container">
                  <i class="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul class="treeview-menu">
                <li
                  :key="idx"
                  v-for="(child, idx) in route.children"
                  v-apply-rules="child.meta.permissions"
                  :class="{ treeview: child.children }"
                >
                  <a
                    :href="`#${child.path}`"
                    v-if="!child.children"
                  >
                    <i :class="child.meta.icon"></i>
                    <span>{{child.meta.label}}</span>
                  </a>
                  <template v-else>
                    <a
                      :href="`#`"
                      @click.prevent
                    >
                      <i :class="child.meta.icon"></i>
                      <span>{{child.meta.label}}</span>
                      <span class="pull-right-container">
                        <i class="fa fa-angle-left pull-right"></i>
                      </span>
                    </a>
                    <ul class="treeview-menu">
                      <li
                        v-for="(nestChild, idx) in child.children"
                        :key="idx"
                      >
                        <a
                          :href="`#${child.path}/${nestChild.path}`"
                          v-if="!nestChild.children"
                        >
                          <i :class="nestChild.meta.icon"></i>
                          <span>{{nestChild.meta.label}}</span>
                        </a>
                      </li>
                    </ul>
                  </template>
                </li>
              </ul>
            </template>
          </li>
        </ul>
      </section>
    </aside>
    <div :class="{ 'content-wrapper': usuarioLogado.basic && usuarioLogado.basic.idUsuario }">
      <slot></slot>
    </div>
    <modal
      v-if="modalUsuario"
      classes="modal-lg"
      :show-footer="false"
      @close="modalUsuario = !modalUsuario"
    >
      <div slot="modal-title">
        Editar meus dados
      </div>
      <div slot="modal-body">
        <usuario-form v-model="usuarioLogado">
        </usuario-form>
      </div>
    </modal>
  </div>
</template>

<script>
import router from '../router/index'
import SelecaoEmpresa from './SelecaoEmpresa.vue'
import NivelLabel from './NivelLabel.vue'
import _ from 'lodash'
import Updater from './Updater.vue'
import Modal from './Modal.vue'
import UsuarioForm from '../app/Usuarios/Form.vue'
import EmpresaPendencias from '../app/Empresas/EmpresaPendencias.vue'
import Permissions from '../models/Permissions'

export default {
  name: 'main-sidebar',
  data () {
    return {
      routes: [],
      activePath: '',
      permissions: Permissions,
      groupIcons: {
        'Arquivos': 'fa fa-file',
        'Cadastros': 'fa fa-pencil',
        'Controladoria': 'fa fa-bar-chart-o',
        'Configurações': 'fa fa-sliders',
        'Contabil': 'fa fa-calculator',
        'Folha': 'fa fa-pencil',
        'ICMS': 'fa fa-calculator',
        'NCM': 'fa fa-book',
        'Utilitários': 'fa fa-hourglass-o',
        // 'SPEDS': 'fa fa-file',
        'SPEDS / DeSTDA': 'fa fa-file',
        'Simples Nacional': 'fa fa-files-o',
        'Auditoria': 'fa fa-pencil',
        'Gerencial': 'fa fa-cog'
      },
      mainSidebar: '',
      hasUpdate: false,
      updateMessage: '',
      modalUsuario: false
    }
  },
  mounted () {
    this.routes = router.options.routes.filter(route => route.meta.showInMenu)
    this.activePath = this.$route.path

    let groups = _.groupBy(this.routes, 'meta.group')

    this.routes = Object.keys(groups).map(group => {
      if (groups[group].length === 1) {
        return groups[group][0]
      }

      return { name: group, children: groups[group] }
    })

    // Inicializar o AdminLTE treeview após o DOM estar pronto
    this.$nextTick(() => {
      setTimeout(() => {
        this.initializeTreeview()
      }, 100)
    })
  },
  methods: {
    initializeTreeview() {
      // Aguardar o jQuery e AdminLTE estarem disponíveis
      if (typeof window.$ !== 'undefined' && window.$.AdminLTE) {
        // Inicializar o treeview do AdminLTE
        window.$('[data-widget="tree"]').tree()
      } else {
        // Fallback manual se o AdminLTE não estiver disponível
        this.manualTreeview()
      }
    },

    manualTreeview() {
      const $ = window.$
      if (!$) return

      // Inicializar todos os treeviews, incluindo aninhados
      $('.sidebar-menu .treeview').each(function() {
        const $this = $(this)
        const $link = $this.find('> a')
        const $menu = $this.find('> .treeview-menu')

        $link.off('click.treeview').on('click.treeview', function(e) {
          e.preventDefault()

          if ($this.hasClass('active')) {
            $this.removeClass('active')
            $menu.slideUp(300)
            $link.find('.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-left')
          } else {
            // Fechar outros menus do mesmo nível
            $this.siblings('.treeview.active').each(function() {
              $(this).removeClass('active')
              $(this).find('> .treeview-menu').slideUp(300)
              $(this).find('> a .fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-left')
            })

            $this.addClass('active')
            $menu.slideDown(300)
            $link.find('.fa-angle-left').removeClass('fa-angle-left').addClass('fa-angle-down')
          }
        })

        // Inicializar submenus aninhados
        $menu.find('.treeview').each(function() {
          const $subThis = $(this)
          const $subLink = $subThis.find('> a')
          const $subMenu = $subThis.find('> .treeview-menu')

          $subLink.off('click.subtreeview').on('click.subtreeview', function(e) {
            e.preventDefault()

            if ($subThis.hasClass('active')) {
              $subThis.removeClass('active')
              $subMenu.slideUp(300)
              $subLink.find('.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-left')
            } else {
              // Fechar outros submenus do mesmo nível
              $subThis.siblings('.treeview.active').each(function() {
                $(this).removeClass('active')
                $(this).find('> .treeview-menu').slideUp(300)
                $(this).find('> a .fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-left')
              })

              $subThis.addClass('active')
              $subMenu.slideDown(300)
              $subLink.find('.fa-angle-left').removeClass('fa-angle-left').addClass('fa-angle-down')
            }
          })
        })
      })
    }
  },
  computed: {
    empresaSelecionada () {
      return this.$store.getters.getCompany
    },
    isMenuToggled () {
      return this.$store.getters.getMenu
    },
    usuarioLogado () {
      return this.$store.getters.getUser
    }
  },
  watch: {
    '$route.path': function (path) {
      this.activePath = path
    },
    routes: {
      handler() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initializeTreeview()
          }, 150)
        })
      },
      deep: true
    }
  },
  components: {
    SelecaoEmpresa,
    NivelLabel,
    Updater,
    Modal,
    UsuarioForm,
    EmpresaPendencias
  }
}
</script>

<style lang="css" scoped>
@media only screen and (min-width: 1400px) {
  aside {
    position: fixed;
    top: 0;
  }

}
.overflow-hack {
  overflow: visible !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
